<template>
  <canvas class="sound-wave-canvas" ref="soundWaveCanvas" hidden></canvas>
</template>

<script setup lang="ts">
import { debounce } from '@/utils'
import { onMounted, ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    waveForm?: any[]
    width?: number
    height?: number
    barThickness?: number
    spaceBetweenBars?: number
    barHeight?: number
    colors?: string[]
  }>(),
  {
    waveForm: () => [],
    width: 600,
    height: 200,
    barThickness: 1,
    spaceBetweenBars: 1,
    barHeight: 0,
    colors: () => ['black'],
  }
)

const emit = defineEmits<{
  (e: 'change-image-sound-wave', image: string): void
}>()

const soundWaveCanvas = ref(null)

function renderWaveForm() {
  let canvasWidth = props.width
  let canvasHeight = props.height
  const barThickness = props.barThickness //the with for 1 wave (pixel)
  const widthPerWave = props.barThickness + props.spaceBetweenBars //the width to genarate 1 wave on it (pixel)
  const colors = props.colors

  const canvas = soundWaveCanvas.value! as HTMLCanvasElement
  canvas.width = canvasWidth
  canvas.height = canvasHeight

  let context = canvas.getContext('2d') as CanvasRenderingContext2D
  const waveHeightDefault = 1 // 1 pixel

  for (let x = 0; x < canvasWidth; x++) {
    // x is postion pixel in width of canvas
    if (x % widthPerWave == 0) {
      let index = Math.ceil(props.waveForm.length * (x / canvasWidth))
      let waveHeight =
        Math.round(props.waveForm[index] * canvasHeight) / 2 ||
        waveHeightDefault

      // draw color sound wave
      const gradient = context.createLinearGradient(0, 0, canvasWidth, 0)
      colors.forEach((color, index) => {
        gradient.addColorStop((1 / colors.length) * (index + 0.5), color)
      })
      context.fillStyle = gradient

      // draw bar thickness
      context.fillRect(
        x,
        canvasHeight / 2 - waveHeight + 1,
        barThickness,
        waveHeight
      )
      context.fillRect(x, canvasHeight / 2, barThickness, waveHeight)
    }
  }
}

function renderImageSoundWave() {
  renderWaveForm()
  const canvas = soundWaveCanvas.value! as HTMLCanvasElement
  if (props.waveForm.length) {
    emit('change-image-sound-wave', canvas.toDataURL('image/png'))
  }
}

onMounted(() => {
  const debounceRenderSoundWave = debounce(renderImageSoundWave, 500)
  watch(
    () => [
      props.barThickness,
      props.spaceBetweenBars,
      props.colors,
      props.waveForm,
    ],
    () => {
      debounceRenderSoundWave()
    },
    {
      immediate: true,
    }
  )
})
</script>
